import { Box, Paper, Stack } from "@mui/material";
import DynamicForm from "./Form";

const FormSection = ({ params, dispatchParams, setOpen }) => {
  return (
    <Box>
      <Paper sx={{ width: "100%" }}>
        <DynamicForm
          params={params}
          dispatchParams={dispatchParams}
          setOpen={setOpen}
        />
      </Paper>
    </Box>
  );
};

export default FormSection;
